import React from 'react';
import PropTypes from 'prop-types';

import styles from './image.module.scss';

function Image(props) {
  const {
    caption,
    image,
    title,
  } = props;
  return (
    <div className={styles.imgContainer}>
      <img className={styles.img} src={image.file.url} alt={title} />
      {caption && (
        <p className={styles.caption}>{caption}</p>
      )}
    </div>
  );
}

export default Image;

Image.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string,
  image: PropTypes.shape({
    file: PropTypes.shape({
      url: PropTypes.string,
    }),
  }).isRequired,
};

Image.defaultProps = {
  caption: '',
};
